/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Swift_Heron_FlyInputs */

const en_bold_swift_heron_fly = /** @type {(inputs: Bold_Swift_Heron_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add child node`)
};

const de_bold_swift_heron_fly = /** @type {(inputs: Bold_Swift_Heron_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindknoten hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add child node" |
*
* @param {Bold_Swift_Heron_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_swift_heron_fly = /** @type {((inputs?: Bold_Swift_Heron_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Swift_Heron_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_swift_heron_fly(inputs)
	return de_bold_swift_heron_fly(inputs)
});